export default __webpack_public_path__ + "static/media/TopFlow.cbf647f1.JPEG";